<template>
  <v-hover v-slot="{ hover }">
    <v-card outlined :elevation="hover ? 4 : 1" @click="navigation" :data-testid="dataTestid">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            style="text-overflow: none !important; white-space: wrap !important"
          >
            <strong>{{ nom }}</strong>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <a-association-etat-chip etat="RECTIFIEE_OFFICE" v-if="requete.rectifieeOffice" class="mr-1"/>
          <a-requete-etat-chip :etat="requete.etat" />
        </v-list-item-icon>
      </v-list-item>
      <v-card-text>
        <div style="align-items: center; display: flex;">
          Référence de la requête :&nbsp;
          <span data-testid="reference-requete">{{ requete.numero }}</span>
          <a-issue-teleservice-icon v-if="requete.issuTeleservice" />
        </div>
        <div>Siège : {{ requete.codePostal }} - {{ requete.commune }}</div>
        <div>Déclarant : {{ requete.declarant }}</div>
      </v-card-text>
      <v-card-actions style="height:42px; !important">
        <template v-if="hasDemandesPieces">
          <v-hover v-slot="{ hover }">
            <v-btn data-testid="repondre-demande-piece-jointe" block :outlined="hover" depressed color="warning">
              <v-icon>mdi-alert</v-icon>
              Répondre à la demande de pièces
            </v-btn>
          </v-hover>
        </template>
      </v-card-actions>
      <v-divider class="mt-1 mb-1" />
      <v-card-actions style="height:42px; !important">
        <v-chip v-if="hasNouveauxDocuments" color="primary"> Nouveaux documents disponibles </v-chip>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
import { toDetailRequete } from "@/routes/requetes";
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    dataTestid: {
      type: String,
      required: false,
    },
  },
  methods: {
    navigation() {
      this.$router.push(toDetailRequete(this.requete.numero));
    },
  },
  computed: {
    demandesPieces() {
      return this.value.demandesPieces;
    },
    hasDemandesPieces() {
      return this.demandesPieces.length > 0;
    },
    hasNouveauxDocuments() {
      return this.requete.nouveauxDocuments;
    },
    nom() {
      return this.requete.nom;
    },
    requete() {
      return this.value.requete;
    },
  },
};
</script>
